import type { ReactNode } from 'react';
import type { ResolvedRelevantParty } from '@momentum/types';
import {
  parseMentionMarkers,
  type MentionSegment,
} from '@/shared/utils/mention-parser';

interface MentionTextProps {
  title: string;
  resolvedRelevantParties?: ResolvedRelevantParty[];
  className?: string;
}

export function MentionText({
  title,
  resolvedRelevantParties,
  className,
}: MentionTextProps): ReactNode {
  const segments = parseMentionMarkers(title);

  if (segments.length === 1 && segments[0]?.type === 'text') {
    return <span className={className}>{title}</span>;
  }

  const resolvedNameMap = new Map(
    (resolvedRelevantParties ?? []).map((party) => [party.id, party.name])
  );

  return (
    <span className={className}>
      {segments.map((segment, index) =>
        segment.type === 'text' ? (
          <span key={index}>{segment.content}</span>
        ) : (
          <MentionChip
            key={index}
            segment={segment}
            resolvedName={resolvedNameMap.get(segment.entityId)}
          />
        )
      )}
    </span>
  );
}

function MentionChip({
  segment,
  resolvedName,
}: {
  segment: MentionSegment & { type: 'mention' };
  resolvedName: string | undefined;
}) {
  const displayName = resolvedName ?? segment.content;

  return (
    <span className="inline text-[#5e6ad2] font-medium bg-[rgba(94,106,210,0.08)] rounded-sm px-0.5">
      @{displayName}
    </span>
  );
}
